import actions from "./actions";

const initState = {
    backupAttachmentsState: false,
    backupDatabaseState: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.BACKUP_ATTACHMENTS_REQUEST:
            return {
                ...state,
                backupAttachmentsState: 'request',
            };
        case actions.BACKUP_ATTACHMENTS_SUCCESS:
            return {
                ...state,
                backupAttachmentsState: 'success',
            };
        case actions.BACKUP_ATTACHMENTS_ERROR:
            return {
                ...state,
                backupAttachmentsState: 'error',
            };
        case actions.BACKUP_DATABASE_REQUEST:
            return {
                ...state,
                backupDatabaseState: 'request',
            };
        case actions.BACKUP_DATABASE_SUCCESS:
            return {
                ...state,
                backupDatabaseState: 'success',
            };
        case actions.BACKUP_DATABASE_ERROR:
            return {
                ...state,
                backupDatabaseState: 'error',
            };
        default:
            return state;
    }
}
